import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import InputMask from 'react-input-mask';
import { Utils } from '../../utils/utils';
import './cadastro.css';

import {
  Footer
} from '../../components';
import closedEye from './closed-eye.svg';
import openedEye from './opened-eye.svg';

export default class ViewCadastro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "render_preloader": false,
      "render_success": false,
      "render_error": false,
      "error_message": "",
      "showPassword": false,
      "showPasswordConfirmation": false,
      "validationErrors": {
        "email": "",
        "cpf": "",
        "password": ""
      },
      "form": {
        "name": "",
        "cpf": "",
        "email": "",
        "password": "",
        "passwordConfirmation": "",
        "checkTerms": false
      }
    }
  }

  componentDidMount() {
  }

  async cadastrar() {
    var _this = this;
    _this.setState({
      "render_preloader": true,
      "render_error": false
    });

    var form = this.state.form;
    var cpf = form.cpf.replaceAll(".", "").replaceAll("-", "");

    try {
      const api_context = await (await fetch('./api_context.json')).json();
      await Sdk.Api.authorization.signinByProjectAnonymous(api_context.project_uid)
      // await Sdk.Api.authorization.initializeFromProject(api_context.project_uid)

      await this.checkUniqueLogin(cpf);

      console.log(Sdk.Api.authorization.activeProject.connectors);
      
      var connector = Sdk.Api.authorization.activeProject.connectors
        .find((connector) =>
          connector.features?.find((f) => f === "IConnectorUserDirectRegister") !== undefined
        );

        const [first, last] = (form.name ?? '').split(' ');
        

      await Sdk.Api.dynamic.bridge(`/auth/v1.1/register/connector/uid/${connector.uid}/direct`, {
        login: cpf,
        password: form.password,
        detail: {
          email_principal: form.email,
          cpf: cpf,
          name: form.name,
          first_name: first ?? '',
          last_name: last ?? '',
        }
      }, 'POST');
      
      _this.setState({
        "render_success": true,
        "render_preloader": false
      });
    } catch (e) {
      _this.setState({
        "render_error": true,
        "render_preloader": false,
        "error_message": e.message || "Verifique os dados informados e tente novamente."
      });
    }
  }

  async checkUniqueLogin(login) {
    await Sdk.Api.dynamic.bridge(`/auth/v1.1/user/login/check?login=${login}`, null, 'POST')
    .catch(() => {
      throw new Error("O CPF informado já está sendo utilizado na plataforma.");
    });
  }

  validateField(field, value) {
    let error = "";
    
    switch (field) {
      case 'email':
        if (value && !this.isValidEmail(value)) {
          error = "Formato de e-mail inválido";
        }
        break;
      case 'cpf':
        if (value && !this.isValidCpf(value)) {
          error = "CPF inválido";
        }
        break;
      case 'password':
        if (value && value.length < 6) {
          error = "Senha deve ter no mínimo 6 caracteres";
        }
        break;
    }
    
    this.setState({
      validationErrors: {
        ...this.state.validationErrors,
        [field]: error
      }
    });
  }

  onBlurField(field, value) {
    this.validateField(field, value);
  }

  onChangeForm(field, value) {
    if (field === 'cpf') {
      value = value.replaceAll(".", "").replaceAll("-", "");
    }
    
    this.setState({
      form: {
        ...this.state.form,
        [field]: value
      }
    });
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  isValidCpf(cpf) {
    cpf = cpf.replace(/[^\d]/g, '');
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    
    let sum = 0;
    for (let i = 0; i < 9; i++) sum += parseInt(cpf[i]) * (10 - i);
    let digit1 = (sum * 10) % 11;
    if (digit1 === 10) digit1 = 0;
    if (digit1 !== parseInt(cpf[9])) return false;
    
    sum = 0;
    for (let i = 0; i < 10; i++) sum += parseInt(cpf[i]) * (11 - i);
    let digit2 = (sum * 10) % 11;
    if (digit2 === 10) digit2 = 0;
    return digit2 === parseInt(cpf[10]);
  }

  isFormValid() {
    const { form } = this.state;
    return form.name.trim() !== "" &&
           this.isValidCpf(form.cpf) &&
           this.isValidEmail(form.email) &&
           form.password.length >= 6 &&
           form.password === form.passwordConfirmation &&
           form.checkTerms;
  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  render() {
    const {
      render_preloader,
      render_success,
      render_error,
      form
    } = this.state;

    return <div className="rdp-react-template-view-cadastro">
      <div className="rdp-react-template-view-cadastro-header">
        <span className="rdp-react-template-view-cadastro-header-logo"></span>
      </div>
      
      {render_preloader &&
        <div className="rdp-react-template-view-cadastro-preloader">
          <div className="rdp-react-template-view-cadastro-preloader-loader"></div>
        </div>
      }

      {render_error &&
        <div className="rdp-react-template-view-cadastro-error">
          <div className="rdp-react-template-view-cadastro-error-box">
            <span className="rdp-react-template-view-cadastro-error-box-icon"></span>
            <h1 className="rdp-react-template-view-cadastro-error-box-title">Erro no cadastro!</h1>
            <p className="rdp-react-template-view-cadastro-error-box-message">
              {this.state.error_message}
            </p>
            <button className="rdp-component-btn primary position-left icon-left" onClick={() => this.setState({"render_error": false})}>Voltar</button>
          </div>
        </div>
      }

      <div className="rdp-react-template-view-cadastro-content">
        {render_success ? (
          <>
            <span className="rdp-react-template-view-cadastro-title">
              Cadastro realizado com sucesso!
            </span>
            <p className="rdp-react-template-view-cadastro-message">
              Agora você pode fazer login com suas credenciais.
            </p>
            <button className="rdp-component-btn primary position-left" onClick={() => this.redirectTo("/login")}>
              Fazer Login
            </button>
          </>
        ) : (
          <>
            <span className="rdp-react-template-view-cadastro-title">
              Cadastro
            </span>
            <p className="rdp-react-template-view-cadastro-subtitle">
              Preencha suas informações para acessar a Biblioteca Digital Senac
            </p>

            <input
              className="rdp-react-template-view-cadastro-input"
              type="text"
              placeholder="Nome completo *"
              value={form.name}
              onChange={(e) => this.onChangeForm('name', e.target.value)}
            />

            <InputMask
              className="rdp-react-template-view-cadastro-input"
              mask="999.999.999-99"
              type="text"
              placeholder="CPF *"
              value={form.cpf}
              onChange={(e) => this.onChangeForm('cpf', e.target.value)}
              onBlur={(e) => this.onBlurField('cpf', e.target.value)}
            />
            {this.state.validationErrors.cpf && (
              <span className="rdp-react-template-view-cadastro-error-text">{this.state.validationErrors.cpf}</span>
            )}

            <input
              className="rdp-react-template-view-cadastro-input"
              type="email"
              placeholder="E-mail *"
              value={form.email}
              onChange={(e) => this.onChangeForm('email', e.target.value)}
              onBlur={(e) => this.onBlurField('email', e.target.value)}
            />
            {this.state.validationErrors.email && (
              <span className="rdp-react-template-view-cadastro-error-text">{this.state.validationErrors.email}</span>
            )}

            <div className="rdp-react-template-view-cadastro-input-container">
              <input
                className="rdp-react-template-view-cadastro-input"
                type={this.state.showPassword ? "text" : "password"}
                placeholder="Senha *"
                value={form.password}
                onChange={(e) => this.onChangeForm('password', e.target.value)}
                onBlur={(e) => this.onBlurField('password', e.target.value)}
              />
              <button
                type="button"
                className="rdp-react-template-view-cadastro-toggle-password"
                tabIndex="-1"
                onClick={() => this.setState({showPassword: !this.state.showPassword})}
              >
                <img src={this.state.showPassword ? openedEye : closedEye} alt="Toggle Password Visibility" />
                {/* {this.state.showPassword ? '👁️' : '👁️‍🗨️'} */}
              </button>
            </div>
            {this.state.validationErrors.password && (
              <span className="rdp-react-template-view-cadastro-error-text">{this.state.validationErrors.password}</span>
            )}

            <div className="rdp-react-template-view-cadastro-input-container">
              <input
                className="rdp-react-template-view-cadastro-input"
                type={this.state.showPasswordConfirmation ? "text" : "password"}
                placeholder="Confirmação da senha *"
                value={form.passwordConfirmation}
                onChange={(e) => this.onChangeForm('passwordConfirmation', e.target.value)}
              />
              <button
                type="button"
                className="rdp-react-template-view-cadastro-toggle-password"
                tabIndex="-1"
                onClick={() => this.setState({showPasswordConfirmation: !this.state.showPasswordConfirmation})}
              >
                <img src={this.state.showPasswordConfirmation ? openedEye : closedEye} alt="Toggle Password Confirmation Visibility" />
                {/* {this.state.showPasswordConfirmation ? '👁️' : '👁️‍🗨️'} */}
              </button>
            </div>
            {form.password && form.passwordConfirmation && form.password !== form.passwordConfirmation && (
              <span className="rdp-react-template-view-cadastro-error-text">As senhas não coincidem</span>
            )}

            <div className="rdp-react-template-view-cadastro-terms">
              <label className="rdp-react-template-view-cadastro-terms-label">
                <input
                  type="checkbox"
                  checked={form.checkTerms}
                  onChange={(e) => this.onChangeForm('checkTerms', e.target.checked)}
                />
                <span>Aceito a <a href="https://www.sp.senac.br/politica-de-privacidade" target="_blank" rel="noreferrer">Política de Privacidade</a> do Senac São Paulo</span>
              </label>
            </div>

            <div className="rdp-component-btn-group-flex">
              <button className="rdp-component-btn secondary position-left icon-left" onClick={() => this.redirectTo("/login")}>Voltar</button>
              <button 
                className={`rdp-component-btn primary position-right icon-right ${!this.isFormValid() ? "inactive" : ""}`} 
                onClick={() => this.cadastrar()}
                disabled={!this.isFormValid()}
              >
                {render_preloader ? "Aguarde..." : "Cadastrar"}
              </button>
            </div>
          </>
        )}
      </div>

      <Footer style={{ width: '100%' }} />
    </div>;
  }
}